import { Attach } from '@/components';
import { useAppClippo } from '@/core';
import { useClippoBlobs } from '@/utils';
import { Col, Row } from 'antd';
import { useCommunityContext } from '../Communities.Common';
import { useUserContextSelector } from '@/redux';

interface Props {
  communityId: string;
  className?: string;
}

export const HomeCommunityAttachments = (props: Props) => {
  const { communityId, className } = props;

  const { active } = useCommunityContext();
  const hasRole = useUserContextSelector((x) => x.hasRole);

  const canModifyCommunity =
    (hasRole('BFP_ADMIN') || hasRole('CLIENT_ADMIN')) && active;

  const communintyClippoProps = useAppClippo({
    defer: false,
    ownerId: communityId,
    ownerType: 'Community',
  });
  const communintyClippoBlobs = useClippoBlobs(communintyClippoProps);

  return (
    <Row>
      <Col>
        <Attach
          className={className}
          {...communintyClippoProps}
          readonly={!canModifyCommunity}
          showActions
          blobs={communintyClippoBlobs.blobs}
        />
      </Col>
    </Row>
  );
};
